import {Injectable} from '@angular/core';
import Guide from '@app/core/models/guide.model';

import {AppSyncHelper} from '@coach-bot/data-access/core';

import {GetGuidesQuery} from 'app/API.service';
import {getGuides} from 'graphql/queries';

import {ObjectMapper} from 'json-object-mapper';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export default class GuideService {
  public constructor(private readonly _appSync: AppSyncHelper) {}

  public list(): Observable<Guide[]> {
    return this._appSync
      .query(getGuides, null)
      .pipe(map((response: GetGuidesQuery) => ObjectMapper.deserializeArray(Guide, response.getGuides)));
  }
}
